import { z } from "zod";
import { twinFileResponseSchema, twinFileTargetSchema } from "../twin-files.js";
import { defineOperation } from "./http.js";
const request = { params: z.object({ fileId: z.string().min(1) }).strict(), body: twinFileTargetSchema };
const openapi = { description: "Changes one attachment without copying or deleting file content. Existing file and destination access checks apply.", responseDescription: "Successful file operation", errors: [400, 401, 403, 404, 413] };
export const TWIN_FILE_LINK_OPERATIONS = {
    attachFile: defineOperation({
        operationId: "twin.files.attach", method: "POST", path: "/api/twin/files/{fileId}/links",
        audience: "public", requiredScope: "twin.write", rateClass: "create", request,
        response: { kind: "json", status: 200, schema: twinFileResponseSchema },
        sdk: { namespace: "twin", method: "attachTwinFile" }, mcpTool: "twin_file_attach",
        openapi: { ...openapi, summary: "Attach an existing file without copying bytes" },
    }),
    detachFile: defineOperation({
        operationId: "twin.files.detach", method: "DELETE", path: "/api/twin/files/{fileId}/links",
        audience: "public", requiredScope: "twin.write", rateClass: "create", request,
        response: { kind: "json", status: 200, schema: twinFileResponseSchema },
        sdk: { namespace: "twin", method: "detachTwinFile" }, mcpTool: "twin_file_detach",
        openapi: { ...openapi, summary: "Remove one attachment and retain the file" },
    }),
};
